import React from 'react';
export function Content() {
  return <>
      <section className="bg-white py-16" data-id="element-22">
        <div className="max-w-4xl mx-auto px-6" data-id="element-23">
          <div className="md:grid md:grid-cols-2 md:gap-12 items-start" data-id="element-24">
            <div className="font-body text-lg leading-relaxed mb-16 md:mb-0" data-id="element-25">
              <div className="mb-8 md:mb-12" data-id="element-26">
                <h2 className="font-heading font-light text-xl sm:text-2xl md:text-3xl lg:text-4xl tracking-wide mb-4 md:mb-6 max-w-full" data-id="element-27">
                  Martha Carey-Lee, MS, FNP-C, LSO
                </h2>
                <p className="font-body text-base sm:text-lg md:text-xl lg:text-2xl tracking-wider uppercase pr-4 md:pr-8 overflow-hidden whitespace-nowrap" data-id="element-28">
                  Owner, Fight Club Med Spa
                </p>
              </div>
              <p data-id="element-29">
                Martha has a Masters of Science in Nursing with FNP-C (Family
                Nurse Practitioner, Certified nationally). LSO stands for Laser
                Safety Operator. She is also a certified Cosmetic Injector, and
                has had 6 years of training in PDO threads by Miracu,
                Novathreads, Empire & Masterthreads.
              </p>
            </div>
            <div className="max-w-xl md:max-w-full mx-auto" data-id="element-30">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2pLwG5C9kiqHgT3aVdmiCF/new_headshot.jpg" alt="Martha Carey-Lee" className="w-full max-w-[22.4rem] md:max-w-lg mx-auto rounded-lg object-cover object-[center_15%] aspect-[3/4]" data-id="element-31" />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[rgba(250,179,212,0.1)] pt-20 pb-16" id="about" data-id="element-32">
        <div className="max-w-4xl mx-auto px-6" data-id="element-33">
          <h2 className="font-heading font-light text-3xl md:text-4xl text-center mb-12 leading-tight tracking-wide" data-id="element-34">
            Appearances aren't everything... but they can change lives.
          </h2>
          <div className="font-body space-y-8 text-lg leading-relaxed" data-id="element-35">
            <p data-id="element-36">
              Growing up in Zimbabwe, Africa, where our family lived during the
              1960's, I was in awe of my father, a surgeon who beautifully
              repaired cleft palates and burn wounds. Years later, as an RN, I
              was able to assist him occasionally in his plastic surgery office.
              When later I became a family nurse practitioner, I fell back into
              making people look better when I co-founded a medical aesthetics
              clinic with a friend in 2010. In 2012 I founded Fight Club Med Spa
              as my traveling aesthetics company.
            </p>
            <p data-id="element-37">
              The changes we choose in a patient's appearance give them renewed
              confidence to go into the world again. One of my first cosmetic
              patients was a school cop, who confessed that her deep frown lines
              made the kids afraid of her. BnTx so improved her "frown" that it
              changed her ability to approach & befriend schoolchildren. Other
              patients come in with extremely low self esteem having just gone
              through a difficult divorce or loss. Some patients are just
              feeling "old" even though they are active and youthful of mind.
            </p>
            <p data-id="element-38">
              It is redeeming to adjust a face or body to the person inside.
              With <strong data-id="element-39">Fight Club Med Spa</strong>, natural looking results,
              discretion and word-of-mouth are all part of the motto:{' '}
              <em data-id="element-40">We're fighting aging!</em> Bring a trusted friend! Because:
              "What happens in Fight Club stays in Fight Club..."
            </p>
          </div>
          <div className="mt-8 mb-6" data-id="element-41">
            <img src="https://images.squarespace-cdn.com/content/v1/5d69727e387da800014a7af2/1572403307381-M9Z61041O548R82ORBNH/martha-01.png" alt="Martha's signature" className="h-24 mx-auto" data-id="element-42" />
          </div>
        </div>
      </section>
    </>;
}